<script>
  import { onMount } from 'svelte';

  // Directly define your API key here
  const API_KEY = 'd1166705b82c4375b9b98d692d1f9009';

  export let chain;
  export let address;
  export let identifier;

  let nftData = null;
  let isLoading = true;

  onMount(async () => {
    const url = `https://api.opensea.io/api/v2/chain/${chain}/contract/${address}/nfts/${identifier}`;
    const response = await fetch(url, {
      headers: {
        'X-API-KEY': API_KEY,
      },
    });
    if (response.ok) {
      const data = await response.json();
      nftData = data.nft;
      isLoading = false;
    } else {
      console.error('Failed to fetch NFT data');
      isLoading = false;
    }
  });
</script>

{#if isLoading}
  <p>Loading...</p>
{:else if nftData}
  <div class="nft-container">
    <!-- Make the image itself a link -->
    <a href={nftData.opensea_url} target="_blank">
      <img src={nftData.image_url} alt={nftData.name} class="nft-image" />
    </a>
    <!-- Keep the Buy Now button as an additional option -->
    <a href={nftData.opensea_url} class="buy-now-btn" target="_blank">Buy Now</a>
  </div>
{:else}
  <p>NFT data could not be loaded.</p>
{/if}


<style>
  .nft-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    margin-top: auto; /* Pushes the content to the bottom */
  }

  .nft-image {
    max-width: 100%;
    height: auto;
    margin-bottom: 20px;
  }

  .buy-now-btn {
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    text-decoration: none;
    border-radius: 5px;
  }
</style>
